var map = {
	"./pages/about/about.module": [
		"./src/app/pages/about/about.module.ts",
		"pages-about-about-module"
	],
	"./pages/advisor/advisor.module": [
		"./src/app/pages/advisor/advisor.module.ts",
		"pages-advisor-advisor-module"
	],
	"./pages/contact/contact.module": [
		"./src/app/pages/contact/contact.module.ts",
		"pages-contact-contact-module"
	],
	"./pages/group/group.module": [
		"./src/app/pages/group/group.module.ts",
		"pages-group-group-module"
	],
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"pages-home-home-module"
	],
	"./pages/last-purchase/last-purchase.module": [
		"./src/app/pages/last-purchase/last-purchase.module.ts",
		"pages-last-purchase-last-purchase-module"
	],
	"./pages/payment-confirmation/payment-confirmation.module": [
		"./src/app/pages/payment-confirmation/payment-confirmation.module.ts",
		"common",
		"pages-payment-confirmation-payment-confirmation-module"
	],
	"./pages/payment/payment.module": [
		"./src/app/pages/payment/payment.module.ts",
		"pages-payment-payment-module"
	],
	"./pages/stripe-checkout/stripe-checkout.module": [
		"./src/app/pages/stripe-checkout/stripe-checkout.module.ts",
		"common",
		"pages-stripe-checkout-stripe-checkout-module"
	],
	"src/app/pages/product/product.module": [
		"./src/app/pages/product/product.module.ts",
		"src-app-pages-product-product-module"
	],
	"src/app/pages/shop/components/order/order.module": [
		"./src/app/pages/shop/components/order/order.module.ts",
		"src-app-pages-shop-components-order-order-module"
	],
	"src/app/pages/shop/shop.module": [
		"./src/app/pages/shop/shop.module.ts",
		"src-app-pages-shop-shop-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;